var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 581.4 774.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #a1ff63;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M541.3,495.9L120.2,762.8c-38.3,24.3-87.3,9.9-109.4-32.2h0c-22.1-42.1-9-95.8,29.3-120.1l421.2-266.9c38.3-24.3,87.3-9.9,109.4,32.2h0c22.1,42.1,9,95.9-29.3,120.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M449.7,477.5L59.7,158.5c-35.5-29-42.8-84.1-16.4-123.1h0C69.8-3.5,120-11.6,155.4,17.4l390,319c35.5,29,42.8,84.1,16.4,123.1h0c-26.4,39-76.6,47-112.1,18h0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForward);
export default __webpack_public_path__ + "static/media/forward.75d5b0dd580cae908e35076e839815d1.svg";
export { ForwardRef as ReactComponent };